import React from 'react';
import useInView from '../hooks/useInView';
import useMotionPrefs from '../hooks/useMotionPrefs';

/* ==================================================================
   ScrollReveal
   ------------------------------------------------------------------
   The one reveal primitive used across the page. It only toggles a
   data attribute; the transition itself is declared once in CSS, so
   a hundred reveals still cost one class-name flip each.
   ================================================================== */

export default function ScrollReveal({
  as: Tag = 'div',
  variant = 'up',
  delay = 0,
  threshold,
  className = '',
  style,
  children,
  ...rest
}) {
  const { reduced } = useMotionPrefs();
  const [ref, inView] = useInView({ threshold, skip: reduced });

  return (
    <Tag
      ref={ref}
      className={`hs-reveal hs-reveal--${variant} ${className}`.trim()}
      data-in={inView ? 'true' : 'false'}
      style={delay ? { ...style, '--hs-delay': `${delay}ms` } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
